import { render, staticRenderFns } from "./express.vue?vue&type=template&id=6ce2e81c&scoped=true&"
import script from "./express.vue?vue&type=script&lang=js&"
export * from "./express.vue?vue&type=script&lang=js&"
import style0 from "./express.vue?vue&type=style&index=0&id=6ce2e81c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce2e81c",
  null
  
)

export default component.exports